"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.number.constructor");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

var _SelectBoxes = _interopRequireDefault(require("../selectboxes/SelectBoxes"));

var _ExpertiseComponent2 = _interopRequireDefault(require("./ExpertiseComponent"));

var _SelectBoxesEdit = _interopRequireDefault(require("../selectboxes/editSelectBoxes/SelectBoxes.edit.validation"));

var _BaseExpertiseForm = _interopRequireDefault(require("./BaseExpertiseForm"));

var _Radio = require("./Radio");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var SelectBoxes =
/*#__PURE__*/
function (_ExpertiseComponent) {
  _inherits(SelectBoxes, _ExpertiseComponent);

  function SelectBoxes(component, options, data) {
    var _this;

    _classCallCheck(this, SelectBoxes);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SelectBoxes).call(this, component, options, data));
    _this.valueScoreMap = _this.component.values.reduce(function (obj, val) {
      obj[val.value] = val.score;
      return obj;
    }, {});
    _this.minScore = _this.component.values.reduce(function (min, val) {
      return val.score < min ? val.score : min;
    }, Number.MAX_VALUE);
    _this.maxScore = _this.component.values.reduce(function (max, val) {
      return val.score > max ? val.score : max;
    }, 0);
    return _this;
  }

  _createClass(SelectBoxes, [{
    key: "getScore",
    value: function getScore() {
      var value = this.dataValue;
      var score = 0;

      for (var key in value) {
        if (value.hasOwnProperty(key) && value[key]) {
          score = score + Number(this.valueScoreMap[key]);
        }
      }

      return score ? score : 0;
    }
  }, {
    key: "getMinScore",
    value: function getMinScore() {
      return this.minScore;
    }
  }, {
    key: "getMaxScore",
    value: function getMaxScore() {
      return this.maxScore;
    }
  }, {
    key: "defaultSchema",
    get: function get() {
      return SelectBoxes.schema();
    }
  }], [{
    key: "schema",
    value: function schema() {
      for (var _len = arguments.length, extend = new Array(_len), _key = 0; _key < _len; _key++) {
        extend[_key] = arguments[_key];
      }

      return _SelectBoxes.default.schema.apply(_SelectBoxes.default, [{
        type: 'expertiseSelectBoxes',
        label: 'Select Boxes',
        key: 'expertiseSelectBoxes'
      }].concat(extend));
    }
  }, {
    key: "editForm",
    value: function editForm() {
      for (var _len2 = arguments.length, extend = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        extend[_key2] = arguments[_key2];
      }

      return _BaseExpertiseForm.default.apply(void 0, [[{
        key: 'display',
        components: _Radio.RadioEditDisplay
      }, {
        key: 'validation',
        components: _SelectBoxesEdit.default
      }, {
        label: 'Expertise',
        key: 'expertise',
        weight: 15,
        components: [{
          type: 'number',
          input: true,
          weight: 10,
          key: 'weight',
          label: 'Вес',
          validate: {
            required: true
          }
        }]
      }]].concat(extend));
    }
  }, {
    key: "builderInfo",
    get: function get() {
      return {
        title: 'Select Boxes',
        icon: 'fa fa-plus-square',
        group: 'expertise',
        weight: 40,
        schema: SelectBoxes.schema()
      };
    }
  }]);

  return SelectBoxes;
}((0, _ExpertiseComponent2.default)(_SelectBoxes.default));

exports.default = SelectBoxes;